// https://stackoverflow.com/a/326076/155119
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
